import { Component, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { delay, withLatestFrom, takeWhile } from 'rxjs/operators';
import { ISubscription } from 'rxjs/Subscription';

import {
  NbMediaBreakpoint,
  NbMediaBreakpointsService,
  NbMenuItem,
  NbMenuService,
  NbSidebarService,
  NbThemeService,
} from '@nebular/theme';

import { StateService } from '../../../@core/utils';
// <nb-layout-column class="main-content" [ngStyle]="{'padding':analyticsPage === true ? '0' : '2em'}">

// <nb-sidebar right tag="notification-sidebar" responsive>
//         <ng-content  select="div.alerts-body"></ng-content>
//       </nb-sidebar>

// TODO: move layouts into the framework
@Component({
  selector: 'ngx-no-menu-layout',
  styleUrls: ['./no-menu.layout.scss'],
  template: `
    <nb-layout [center]="layout.id === 'center-column'">
      <nb-layout-header fixed>
        <ngx-header [position]="sidebar.id === 'start' ? 'normal': 'inverse'" [menuTog]='false'></ngx-header>
      </nb-layout-header>
     
      <nb-layout-column class="main-content" [ngStyle]="{'padding':'2em'}">
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-footer fixed>
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
    </nb-layout>
  `,
})
// <ngx-toggle-settings-button></ngx-toggle-settings-button>
export class NoMenuLayoutComponent implements OnDestroy {

  subMenu: NbMenuItem[] = [
    {
      title: 'PAGE LEVEL MENU',
      group: true,
    },
    {
      title: 'Buttons',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/buttons',
    },
    {
      title: 'Grid',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/grid',
    },
    {
      title: 'Icons',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/icons',
    },
    {
      title: 'Modals',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/modals',
    },
    {
      title: 'Typography',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/typography',
    },
    {
      title: 'Animated Searches',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/search-fields',
    },
    {
      title: 'Tabs',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/tabs',
    },
  ];
  layout: any = {};
  sidebar: any = {};

  private alive = true;

  currentTheme: string;

  urlLink:any;
  private subscription: ISubscription;

  analyticsPage = false;
  constructor(protected stateService: StateService,
              protected menuService: NbMenuService,
              protected themeService: NbThemeService,
              protected bpService: NbMediaBreakpointsService,
              protected sidebarService: NbSidebarService,
              protected router: Router) {
    
    this.subscription = this.router.events.subscribe(data => {
      if (typeof data == "object"){
        if ('url' in data){ 
         if (data.url.indexOf('/analytics')> 0){
            this.analyticsPage = true;
          }else{
            this.analyticsPage = false;
          }
      }
    }
      // if (data['url'].indexOf('/analytics') > 0){
      //   this.analyticsPage = true;
      //   console.log("IN");
      // }
      // console.log(data['url'].indexOf('/analytics') > 0 )
    })
    // console.log(this.urlLink.indexOf('/analytics'))

    const isBp = this.bpService.getByName('is');
    // this.menuService.onItemSelect()
    //   .pipe(
    //     takeWhile(() => this.alive),
    //     withLatestFrom(this.themeService.onMediaQueryChange()),
    //     delay(20),
    //   )
    //   .subscribe(([item, [bpFrom, bpTo]]: [any, [NbMediaBreakpoint, NbMediaBreakpoint]]) => {

    //     if (bpTo.width <= isBp.width) {
    //       this.sidebarService.collapse('menu-sidebar');
    //     }
    //   });

    this.themeService.getJsTheme()
      .pipe(takeWhile(() => this.alive))
      .subscribe(theme => {
        this.currentTheme = theme.name;
    });
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
